import React, { memo } from 'react';
import PropTypes from 'prop-types';
import IconStyled from './styles/IconStyled';

const Icon = ({
  name,
  fillColor = 'white',
  strokeColor = null,
  size,
  width = null,
  height = null,
  viewBox = null,
  className = '',
}) => {
  const iconHref = typeof name === 'string' ? name : name.id;
  if (iconHref === name) {
    // eslint-disable-next-line no-console
    console.warn('Icon for :', name);
  }
  return (
    <IconStyled
      className={className}
      fill={fillColor === 'inherit' ? null : fillColor}
      stroke={strokeColor}
      width={viewBox !== 'none' ? size : width}
      height={viewBox !== 'none' ? size : height}
      viewBox={viewBox !== 'none' ? viewBox || '0 0 32 32' : null}
    >
      <use xlinkHref={`#${iconHref}`} />
    </IconStyled>
  );
};

Icon.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ id: PropTypes.string }),
  ]).isRequired,
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  size: PropTypes.number,
  viewBox: PropTypes.string,
  className: PropTypes.string,
};

export default memo(Icon);
